import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, TemplateRef} from "@angular/core";
import {NbDialogService} from "@nebular/theme";
import {FormControl, FormGroup} from "@angular/forms";
import {UmbrellaValidators} from "../../../umbrella-common/validation/umbrella-validators";
import {AppState} from "../../../store/state/app.state";
import {Store} from "@ngrx/store";
import {Order} from "../../../store/state/order.state";
import {OrderActions} from "../../../store/actions/order.actions";
import {Actions, ofType} from "@ngrx/effects";
import {Observable, Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {map} from "rxjs/operators";
import {NotificationService} from "../../../umbrella-common/services/notification.service";
import {AuthenticationService} from "../../../authentication/authentication.service";
import {NavigationService} from "../../../navigation.service";

@Component({
    selector: 'decline-order-button',
    templateUrl: './decline-order-button.template.html',
    styleUrls: ['./decline-order-button.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeclineOrderButtonComponent implements OnInit, OnDestroy {

	@Input() order: Order;
	@Input() disabled: boolean;

	declineOrderForm: FormGroup;
	private errorSubscription: Subscription;
	private declineClicked: boolean;

	constructor(private dialogService: NbDialogService, private notifications: NotificationService, private store: Store<AppState>, private actions$: Actions,
				private translate: TranslateService, private authService: AuthenticationService, private navigationService: NavigationService) {
	}

	ngOnInit(): void {
		this.declineOrderForm = new FormGroup({
			decliningReason: new FormControl(null, [UmbrellaValidators.maxLength(5000)])
		});

		this.errorSubscription = this.actions$.pipe(ofType(OrderActions.DECLINE_ORDER_BY_CLIENT_FAILURE))
			.subscribe(action => {
				if (this.declineClicked) {
					this.notifications.error();
					setTimeout(() => {
						if (this.authService.isLoggedUserClient(false)) {
							this.navigationService.navigateToProperOrderStep();
						} else {
							this.navigationService.goToLoginPage();
						}
					}, 1500);
				}
			});
	}

	ngOnDestroy(): void {
		!!this.errorSubscription && this.errorSubscription.unsubscribe();
	}

	showDeclineOfferDialog(dialog: TemplateRef<any>) {
		this.dialogService.open(dialog);
	}

	getDeclineFormErrors(): Observable<string> {
		const errors: string[] = Object.keys(this.declineOrderForm.get('decliningReason').errors)
		return this.translate.get(errors).pipe(map(translations => {
			return errors.map(error => translations[error]).join(', ');
		}));
	}

	declineOffer(dialog): void {
		setTimeout(() => this.doDeclineOffer(dialog), 100);
	}

	private doDeclineOffer(dialog) {
		this.store.dispatch(OrderActions.DECLINE_ORDER_BY_CLIENT({
			correlationId: this.order.orderCorrelationId,
			reason: this.declineOrderForm.controls['decliningReason'].value,
			navigateToDeclinePage: true
		}));
		this.declineClicked = true;
		dialog.close();
	}

	isDeclineReasonControlPristine(): boolean {
		return this.declineOrderForm.controls['decliningReason'].pristine;
	}

	isFormPristine(): boolean {
		return this.declineOrderForm.pristine;
	}
}
